// Table of contents:
// 1 packagingData
// 1.1 Add
// 1.2 Info
// 1.3 Edit
// 3 suppliers
// 3.1 Add
// 3.2 Info
// 3.3 Edit
import { MasterDataManagement } from '../../../data'
import { getTranslationsForConfig } from '../getTranslationsForConfig'

export const createMasterDataManagement = (): MasterDataManagement => {
  return {
    // 1 packagingData
    packagingData: {
      // 1 packagingData
      table: {
        enabled: true,
        columns: [
          {
            // PackagingDataId
            field: 'PackagingDataId',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'masterDataManagement.packagingData.table.columns.packagingDataId.filterPlaceholder',
            ), // t('masterDataManagement.packagingData.table.columns.packagingDataId.filterPlaceholder')
            header: getTranslationsForConfig(
              'masterDataManagement.packagingData.table.columns.packagingDataId.header',
            ), // t('masterDataManagement.packagingData.table.columns.packagingDataId.header')
            sortable: true,
          },
          {
            // Description
            field: 'Description',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'masterDataManagement.packagingData.table.columns.description.filterPlaceholder',
            ), // t('masterDataManagement.packagingData.table.columns.description.filterPlaceholder')
            header: getTranslationsForConfig(
              'masterDataManagement.packagingData.table.columns.description.header',
            ), // t('masterDataManagement.packagingData.table.columns.description.header')
            sortable: true,
          },
          {
            // Type
            field: 'PackagingMaterial',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'masterDataManagement.packagingData.table.columns.packagingMaterial.filterPlaceholder',
            ), // t('masterDataManagement.packagingData.table.columns.packagingMaterial.filterPlaceholder')
            header: getTranslationsForConfig(
              'masterDataManagement.packagingData.table.columns.packagingMaterial.header',
            ), // t('masterDataManagement.packagingData.table.columns.packagingMaterial.header')
            sortable: true,
          },
          {
            // TareWeight
            align: 'right',
            field: 'TareWeight.Value',
            filter: true,
            filterField: 'TareWeight.Value',
            header: getTranslationsForConfig(
              'masterDataManagement.packagingData.table.columns.tareWeight.header',
            ), // t('masterDataManagement.packagingData.table.columns.tareWeight.header')
            sortable: true,
          },
          {
            // TareWeightUnit
            field: 'TareWeight.Unit',
            header: getTranslationsForConfig(
              'masterDataManagement.packagingData.table.columns.tareWeightUnit.header',
            ), // t('masterDataManagement.packagingData.table.columns.tareWeightUnit.header')
          },
          {
            // Volume
            align: 'right',
            field: 'Volume.Value',
            filter: true,
            filterField: 'Volume.Value',
            header: getTranslationsForConfig(
              'masterDataManagement.packagingData.table.columns.volume.header',
            ), // t('masterDataManagement.packagingData.table.columns.volume.header')
            sortable: true,
          },
          {
            // VolumeUnit
            field: 'Volume.Unit',
            header: getTranslationsForConfig(
              'masterDataManagement.packagingData.table.columns.volumeUnit.header',
            ), // t('masterDataManagement.packagingData.table.columns.volumeUnit.header')
          },
          {
            // PackagingIdentifier
            field: 'PackagingIdentifier',
            filter: true,
            header: getTranslationsForConfig(
              'masterDataManagement.packagingData.table.columns.packagingIdentifier.header',
            ), // t('masterDataManagement.packagingData.table.columns.packagingIdentifier.header')
            sortable: true,
          },
          {
            // PropertyIdentifier
            field: 'PropertyIdentifier',
            filter: true,
            header: getTranslationsForConfig(
              'masterDataManagement.packagingData.table.columns.propertyIdentifier.header',
            ), // t('masterDataManagement.packagingData.table.columns.propertyIdentifier.header')
            sortable: true,
          },
          {
            // Stackable
            align: 'center',
            field: 'IsStackable',
            filter: true,
            header: getTranslationsForConfig(
              'masterDataManagement.packagingData.table.columns.isStackable.header',
            ), // t('masterDataManagement.packagingData.table.columns.isStackable.header')
            sortable: true,
          },
        ],
        emptyMessageDetails: getTranslationsForConfig(
          'masterDataManagement.packagingData.table.emptyMessageDetails',
        ), // t('masterDataManagement.packagingData.table.emptyMessageDetails')
        emptyMessageTitle: getTranslationsForConfig(
          'masterDataManagement.packagingData.table.emptyMessageTitle',
        ), // t('masterDataManagement.packagingData.table.emptyMessageTitle')
        paginator: true,
        rows: 20,
        rowsPerPageOptions: [20, 50, 100],
        sortField: 'Id',
        sortOrder: 1,
        // scrollHeight: '70vh',
      },
      // 1.1 Add
      add: {
        enabled: true,
        // PackagingDataId
        packagingDataId: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.add.dialog.form.packagingDataId.label',
          ), // t('masterDataManagement.packagingData.table.add.dialog.form.packagingDataId.label')
          readonly: false,
          validation: {
            isRequired: true,
          },
        },
        // Description
        description: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.add.dialog.form.description.label',
          ), // t('masterDataManagement.packagingData.table.add.dialog.form.description.label')
          readonly: false,
          validation: {
            isRequired: true,
          },
        },
        // PackagingMaterial
        packagingMaterial: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.label',
          ), // t('masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.label')
          readonly: false,
          options: [
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.container',
              ), // t('masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.container')
              code: 'container',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.containerGlass',
              ), // t('masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.containerGlass')
              code: 'containerGlass',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.containerUnit',
              ), // t('masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.containerUnit')
              code: 'containerUnit',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.fiberMoldPackaging',
              ), // t('masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.fiberMoldPackaging')
              code: 'fiberMoldPackaging',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.flexiblePackaging',
              ), // t('masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.flexiblePackaging')
              code: 'flexiblePackaging',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.dimensionallyStablePackaging',
              ), // t('masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.dimensionallyStablePackaging')
              code: 'dimensionallyStablePackaging',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.gasCartridge',
              ), // t('masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.gasCartridge')
              code: 'gasCartridge',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.vessels',
              ), // t('masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.vessels')
              code: 'vessels',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.largeGlassContainer',
              ), // t('masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.largeGlassContainer')
              code: 'largeGlassContainer',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.ibc',
              ), // t('masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.ibc')
              code: 'ibc',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.fibc',
              ), // t('masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.fibc')
              code: 'fibc',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.woodenIbc',
              ), // t('masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.woodenIbc')
              code: 'woodenIbc',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.cardboardIbc',
              ), // t('masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.cardboardIbc')
              code: 'cardboardIbc',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.compositeIbc',
              ), // t('masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.compositeIbc')
              code: 'compositeIbc',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.metalIbc',
              ), // t('masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.metalIbc')
              code: 'metalIbc',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.rigidPlasticIbc',
              ), // t('masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.rigidPlasticIbc')
              code: 'rigidPlasticIbc',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.largePackaging',
              ), // t('masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.largePackaging')
              code: 'largePackaging',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.semiRigidPackaging',
              ), // t('masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.semiRigidPackaging')
              code: 'semiRigidPackaging',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.innerContainer',
              ), // t('masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.innerContainer')
              code: 'innerContainer',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.cartons',
              ), // t('masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.cartons')
              code: 'cartons',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.lightContainer',
              ), // t('masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.lightContainer')
              code: 'lightContainer',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.measuringContainer',
              ), // t('masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.measuringContainer')
              code: 'measuringContainer',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.medicalGlass',
              ), // t('masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.medicalGlass')
              code: 'medicalGlass',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.nestablePackaging',
              ), // t('masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.nestablePackaging')
              code: 'nestablePackaging',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.packagingCut',
              ), // t('masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.packagingCut')
              code: 'packagingCut',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.pallet',
              ), // t('masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.pallet')
              code: 'pallet',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.foamPackaging',
              ), // t('masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.foamPackaging')
              code: 'foamPackaging',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.rigidPackaging',
              ), // t('masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.rigidPackaging')
              code: 'rigidPackaging',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.coatedCarton',
              ), // t('masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.coatedCarton')
              code: 'coatedCarton',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.volumeStablePackaging',
              ), // t('masterDataManagement.packagingData.table.add.dialog.form.packagingMaterial.options.volumeStablePackaging')
              code: 'volumeStablePackaging',
            },
          ],
          validation: {
            isRequired: false,
          },
        },
        // Length
        length: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.add.dialog.form.length.label',
          ), // t('masterDataManagement.packagingData.table.add.dialog.form.length.label')
          readonly: false,
          validation: {
            isRequired: false,
          },
        },
        // Width
        width: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.add.dialog.form.width.label',
          ), // t('masterDataManagement.packagingData.table.add.dialog.form.width.label')
          readonly: false,
          validation: {
            isRequired: false,
          },
        },
        // Height
        height: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.add.dialog.form.height.label',
          ), // t('masterDataManagement.packagingData.table.add.dialog.form.height.label')
          readonly: false,
          validation: {
            isRequired: false,
          },
        },
        // MeasurementsUnit
        measurementsUnit: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.add.dialog.form.measurementsUnit.label',
          ), // t('masterDataManagement.packagingData.table.add.dialog.form.measurementsUnit.label')
          readonly: false,
          options: [
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.add.dialog.form.measurementsUnit.options.MM',
              ), // t('masterDataManagement.packagingData.table.add.dialog.form.measurementsUnit.options.MM')
              code: 'MM',
            },
          ],
          validation: {
            isRequired: false,
          },
        },
        // TareWeight
        tareWeight: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.add.dialog.form.tareWeight.label',
          ), // t('masterDataManagement.packagingData.table.add.dialog.form.tareWeight.label')
          readonly: false,
          validation: {
            isRequired: false,
          },
        },
        // TareWeightUnit
        tareWeightUnit: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.add.dialog.form.tareWeightUnit.label',
          ), // t('masterDataManagement.packagingData.table.add.dialog.form.tareWeightUnit.label')
          readonly: false,
          options: [
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.add.dialog.form.tareWeightUnit.options.KG',
              ), // t('masterDataManagement.packagingData.table.add.dialog.form.tareWeightUnit.options.KG')
              code: 'KG',
            },
          ],
          validation: {
            isRequired: false,
          },
        },
        // Volume
        volume: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.add.dialog.form.volume.label',
          ), // t('masterDataManagement.packagingData.table.add.dialog.form.volume.label')
        },
        // VolumeUnit
        volumeUnit: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.add.dialog.form.volumeUnit.label',
          ), // t('masterDataManagement.packagingData.table.add.dialog.form.volumeUnit.label')
          options: [
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.add.dialog.form.volumeUnit.options.M3',
              ), // t('masterDataManagement.packagingData.table.add.dialog.form.volumeUnit.options.M3')
              code: 'M3',
            },
          ],
        },
        // PackagingIdentifier
        packagingIdentifier: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.add.dialog.form.packagingIdentifier.label',
          ), // t('masterDataManagement.packagingData.table.add.dialog.form.packagingIdentifier.label')
          readonly: false,
          options: [
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.add.dialog.form.packagingIdentifier.options.disposablePackaging',
              ), // t('masterDataManagement.packagingData.table.add.dialog.form.packagingIdentifier.options.disposablePackaging')
              code: 'disposablePackaging',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.add.dialog.form.packagingIdentifier.options.reusablePackaging',
              ), // t('masterDataManagement.packagingData.table.add.dialog.form.packagingIdentifier.options.reusablePackaging')
              code: 'reusablePackaging',
            },
          ],
          validation: {
            isRequired: false,
          },
        },
        // PropertyIdentifier
        propertyIdentifier: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.add.dialog.form.propertyIdentifier.label',
          ), // t('masterDataManagement.packagingData.table.add.dialog.form.propertyIdentifier.label')
          readonly: false,
          options: [
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.add.dialog.form.propertyIdentifier.options.customer',
              ), // t('masterDataManagement.packagingData.table.add.dialog.form.propertyIdentifier.options.customer')
              code: 'customer',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.add.dialog.form.propertyIdentifier.options.supplier',
              ), // t('masterDataManagement.packagingData.table.add.dialog.form.propertyIdentifier.options.supplier')
              code: 'supplier',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.add.dialog.form.propertyIdentifier.options.thirdParties',
              ), // t('masterDataManagement.packagingData.table.add.dialog.form.propertyIdentifier.options.thirdParties')
              code: 'thirdParties',
            },
          ],
          validation: {
            isRequired: false,
          },
        },
        // IsStackable
        isStackable: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.add.dialog.form.isStackable.label',
          ), // t('masterDataManagement.packagingData.table.add.dialog.form.isStackable.label')
          readonly: true,
          validation: {
            isRequired: false,
          },
        },
      },
      // 1.2 Info
      info: {
        enabled: true,
        // PackagingDataId
        packagingDataId: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.info.dialog.form.packagingDataId.label',
          ), // t('masterDataManagement.packagingData.table.info.dialog.form.packagingDataId.label')
        },
        // Description
        description: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.info.dialog.form.description.label',
          ), // t('masterDataManagement.packagingData.table.info.dialog.form.description.label')
        },
        // PackagingMaterial
        packagingMaterial: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.label',
          ), // t('masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.label')
          options: [
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.container',
              ), // t('masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.container')
              code: 'container',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.containerGlass',
              ), // t('masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.containerGlass')
              code: 'containerGlass',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.containerUnit',
              ), // t('masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.containerUnit')
              code: 'containerUnit',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.fiberMoldPackaging',
              ), // t('masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.fiberMoldPackaging')
              code: 'fiberMoldPackaging',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.flexiblePackaging',
              ), // t('masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.flexiblePackaging')
              code: 'flexiblePackaging',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.dimensionallyStablePackaging',
              ), // t('masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.dimensionallyStablePackaging')
              code: 'dimensionallyStablePackaging',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.gasCartridge',
              ), // t('masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.gasCartridge')
              code: 'gasCartridge',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.vessels',
              ), // t('masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.vessels')
              code: 'vessels',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.largeGlassContainer',
              ), // t('masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.largeGlassContainer')
              code: 'largeGlassContainer',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.ibc',
              ), // t('masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.ibc')
              code: 'ibc',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.fibc',
              ), // t('masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.fibc')
              code: 'fibc',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.woodenIbc',
              ), // t('masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.woodenIbc')
              code: 'woodenIbc',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.cardboardIbc',
              ), // t('masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.cardboardIbc')
              code: 'cardboardIbc',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.compositeIbc',
              ), // t('masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.compositeIbc')
              code: 'compositeIbc',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.metalIbc',
              ), // t('masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.metalIbc')
              code: 'metalIbc',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.rigidPlasticIbc',
              ), // t('masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.rigidPlasticIbc')
              code: 'rigidPlasticIbc',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.largePackaging',
              ), // t('masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.largePackaging')
              code: 'largePackaging',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.semiRigidPackaging',
              ), // t('masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.semiRigidPackaging')
              code: 'semiRigidPackaging',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.innerContainer',
              ), // t('masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.innerContainer')
              code: 'innerContainer',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.cartons',
              ), // t('masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.cartons')
              code: 'cartons',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.lightContainer',
              ), // t('masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.lightContainer')
              code: 'lightContainer',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.measuringContainer',
              ), // t('masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.measuringContainer')
              code: 'measuringContainer',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.medicalGlass',
              ), // t('masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.medicalGlass')
              code: 'medicalGlass',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.nestablePackaging',
              ), // t('masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.nestablePackaging')
              code: 'nestablePackaging',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.packagingCut',
              ), // t('masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.packagingCut')
              code: 'packagingCut',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.pallet',
              ), // t('masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.pallet')
              code: 'pallet',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.foamPackaging',
              ), // t('masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.foamPackaging')
              code: 'foamPackaging',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.rigidPackaging',
              ), // t('masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.rigidPackaging')
              code: 'rigidPackaging',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.coatedCarton',
              ), // t('masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.coatedCarton')
              code: 'coatedCarton',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.volumeStablePackaging',
              ), // t('masterDataManagement.packagingData.table.info.dialog.form.packagingMaterial.options.volumeStablePackaging')
              code: 'volumeStablePackaging',
            },
          ],
        },
        // Length
        length: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.info.dialog.form.length.label',
          ), // t('masterDataManagement.packagingData.table.info.dialog.form.length.label')
        },
        // Width
        width: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.info.dialog.form.width.label',
          ), // t('masterDataManagement.packagingData.table.info.dialog.form.width.label')
        },
        // Height
        height: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.info.dialog.form.height.label',
          ), // t('masterDataManagement.packagingData.table.info.dialog.form.height.label')
        },
        // MeasurementsUnit
        measurementsUnit: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.info.dialog.form.measurementsUnit.label',
          ), // t('masterDataManagement.packagingData.table.info.dialog.form.measurementsUnit.label')
          options: [
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.info.dialog.form.measurementsUnit.options.MM',
              ), // t('masterDataManagement.packagingData.table.info.dialog.form.measurementsUnit.options.MM')
              code: 'MM',
            },
          ],
        },
        // TareWeight
        tareWeight: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.info.dialog.form.tareWeight.label',
          ), // t('masterDataManagement.packagingData.table.info.dialog.form.tareWeight.label')
        },
        // TareWeightUnit
        tareWeightUnit: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.info.dialog.form.tareWeightUnit.label',
          ), // t('masterDataManagement.packagingData.table.info.dialog.form.tareWeightUnit.label')
          options: [
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.info.dialog.form.tareWeightUnit.options.KG',
              ), // t('masterDataManagement.packagingData.table.info.dialog.form.tareWeightUnit.options.KG')
              code: 'KG',
            },
          ],
        },
        // Volume
        volume: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.info.dialog.form.volume.label',
          ), // t('masterDataManagement.packagingData.table.info.dialog.form.volume.label')
        },
        // VolumeUnit
        volumeUnit: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.info.dialog.form.volumeUnit.label',
          ), // t('masterDataManagement.packagingData.table.info.dialog.form.volumeUnit.label')
          options: [
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.info.dialog.form.volumeUnit.options.M3',
              ), // t('masterDataManagement.packagingData.table.info.dialog.form.volumeUnit.options.M3')
              code: 'M3',
            },
          ],
        },
        // PackagingIdentifier
        packagingIdentifier: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.info.dialog.form.packagingIdentifier.label',
          ), // t('masterDataManagement.packagingData.table.info.dialog.form.packagingIdentifier.label')
          options: [
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.info.dialog.form.packagingIdentifier.options.disposablePackaging',
              ), // t('masterDataManagement.packagingData.table.info.dialog.form.packagingIdentifier.options.disposablePackaging')
              code: 'disposablePackaging',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.info.dialog.form.packagingIdentifier.options.reusablePackaging',
              ), // t('masterDataManagement.packagingData.table.info.dialog.form.packagingIdentifier.options.reusablePackaging')
              code: 'reusablePackaging',
            },
          ],
        },
        // PropertyIdentifier
        propertyIdentifier: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.info.dialog.form.propertyIdentifier.label',
          ), // t('masterDataManagement.packagingData.table.info.dialog.form.propertyIdentifier.label')
          options: [
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.info.dialog.form.propertyIdentifier.options.customer',
              ), // t('masterDataManagement.packagingData.table.info.dialog.form.propertyIdentifier.options.customer')
              code: 'customer',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.info.dialog.form.propertyIdentifier.options.supplier',
              ), // t('masterDataManagement.packagingData.table.info.dialog.form.propertyIdentifier.options.supplier')
              code: 'supplier',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.info.dialog.form.propertyIdentifier.options.thirdParties',
              ), // t('masterDataManagement.packagingData.table.info.dialog.form.propertyIdentifier.options.thirdParties')
              code: 'thirdParties',
            },
          ],
        },
        // IsStackable
        isStackable: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.info.dialog.form.isStackable.label',
          ), // t('masterDataManagement.packagingData.table.info.dialog.form.isStackable.label')
        },
      },
      // 1.3 Edit
      edit: {
        enabled: true,
        // PackagingDataId
        packagingDataId: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.edit.dialog.form.packagingDataId.label',
          ), // t('masterDataManagement.packagingData.table.edit.dialog.form.packagingDataId.label')
          readonly: false,
          validation: {
            isRequired: true,
          },
        },
        // Description
        description: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.edit.dialog.form.description.label',
          ), // t('masterDataManagement.packagingData.table.edit.dialog.form.description.label')
          readonly: false,
          validation: {
            isRequired: true,
          },
        },
        // PackagingMaterial
        packagingMaterial: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.label',
          ), // t('masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.label')
          readonly: false,
          options: [
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.container',
              ), // t('masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.container')
              code: 'container',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.containerGlass',
              ), // t('masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.containerGlass')
              code: 'containerGlass',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.containerUnit',
              ), // t('masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.containerUnit')
              code: 'containerUnit',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.fiberMoldPackaging',
              ), // t('masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.fiberMoldPackaging')
              code: 'fiberMoldPackaging',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.flexiblePackaging',
              ), // t('masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.flexiblePackaging')
              code: 'flexiblePackaging',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.dimensionallyStablePackaging',
              ), // t('masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.dimensionallyStablePackaging')
              code: 'dimensionallyStablePackaging',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.gasCartridge',
              ), // t('masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.gasCartridge')
              code: 'gasCartridge',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.vessels',
              ), // t('masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.vessels')
              code: 'vessels',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.largeGlassContainer',
              ), // t('masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.largeGlassContainer')
              code: 'largeGlassContainer',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.ibc',
              ), // t('masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.ibc')
              code: 'ibc',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.fibc',
              ), // t('masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.fibc')
              code: 'fibc',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.woodenIbc',
              ), // t('masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.woodenIbc')
              code: 'woodenIbc',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.cardboardIbc',
              ), // t('masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.cardboardIbc')
              code: 'cardboardIbc',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.compositeIbc',
              ), // t('masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.compositeIbc')
              code: 'compositeIbc',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.metalIbc',
              ), // t('masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.metalIbc')
              code: 'metalIbc',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.rigidPlasticIbc',
              ), // t('masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.rigidPlasticIbc')
              code: 'rigidPlasticIbc',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.largePackaging',
              ), // t('masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.largePackaging')
              code: 'largePackaging',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.semiRigidPackaging',
              ), // t('masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.semiRigidPackaging')
              code: 'semiRigidPackaging',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.innerContainer',
              ), // t('masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.innerContainer')
              code: 'innerContainer',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.cartons',
              ), // t('masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.cartons')
              code: 'cartons',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.lightContainer',
              ), // t('masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.lightContainer')
              code: 'lightContainer',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.measuringContainer',
              ), // t('masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.measuringContainer')
              code: 'measuringContainer',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.medicalGlass',
              ), // t('masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.medicalGlass')
              code: 'medicalGlass',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.nestablePackaging',
              ), // t('masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.nestablePackaging')
              code: 'nestablePackaging',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.packagingCut',
              ), // t('masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.packagingCut')
              code: 'packagingCut',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.pallet',
              ), // t('masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.pallet')
              code: 'pallet',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.foamPackaging',
              ), // t('masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.foamPackaging')
              code: 'foamPackaging',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.rigidPackaging',
              ), // t('masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.rigidPackaging')
              code: 'rigidPackaging',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.coatedCarton',
              ), // t('masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.coatedCarton')
              code: 'coatedCarton',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.volumeStablePackaging',
              ), // t('masterDataManagement.packagingData.table.edit.dialog.form.packagingMaterial.options.volumeStablePackaging')
              code: 'volumeStablePackaging',
            },
          ],
          validation: {
            isRequired: false,
          },
        },
        // Length
        length: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.edit.dialog.form.length.label',
          ), // t('masterDataManagement.packagingData.table.edit.dialog.form.length.label')
          readonly: false,
          validation: {
            isRequired: false,
          },
        },
        // Width
        width: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.edit.dialog.form.width.label',
          ), // t('masterDataManagement.packagingData.table.edit.dialog.form.width.label')
          readonly: false,
          validation: {
            isRequired: false,
          },
        },
        // Height
        height: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.edit.dialog.form.height.label',
          ), // t('masterDataManagement.packagingData.table.edit.dialog.form.height.label')
          readonly: false,
          validation: {
            isRequired: false,
          },
        },
        // MeasurementsUnit
        measurementsUnit: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.edit.dialog.form.measurementsUnit.label',
          ), // t('masterDataManagement.packagingData.table.edit.dialog.form.measurementsUnit.label')
          readonly: false,
          options: [
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.edit.dialog.form.measurementsUnit.options.MM',
              ), // t('masterDataManagement.packagingData.table.edit.dialog.form.measurementsUnit.options.MM')
              code: 'MM',
            },
          ],
          validation: {
            isRequired: false,
          },
        },
        // TareWeight
        tareWeight: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.edit.dialog.form.tareWeight.label',
          ), // t('masterDataManagement.packagingData.table.edit.dialog.form.tareWeight.label')
          readonly: false,
          validation: {
            isRequired: false,
          },
        },
        // TareWeightUnit
        tareWeightUnit: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.edit.dialog.form.tareWeightUnit.label',
          ), // t('masterDataManagement.packagingData.table.edit.dialog.form.tareWeightUnit.label')
          readonly: false,
          options: [
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.edit.dialog.form.tareWeightUnit.options.KG',
              ), // t('masterDataManagement.packagingData.table.edit.dialog.form.tareWeightUnit.options.KG')
              code: 'KG',
            },
          ],
          validation: {
            isRequired: false,
          },
        },
        // Volume
        volume: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.edit.dialog.form.volume.label',
          ), // t('masterDataManagement.packagingData.table.edit.dialog.form.volume.label')
        },
        // VolumeUnit
        volumeUnit: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.edit.dialog.form.volumeUnit.label',
          ), // t('masterDataManagement.packagingData.table.edit.dialog.form.volumeUnit.label')
          options: [
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.edit.dialog.form.volumeUnit.options.M3',
              ), // t('masterDataManagement.packagingData.table.edit.dialog.form.volumeUnit.options.M3')
              code: 'M3',
            },
          ],
        },
        // PackagingIdentifier
        packagingIdentifier: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.edit.dialog.form.packagingIdentifier.label',
          ), // t('masterDataManagement.packagingData.table.edit.dialog.form.packagingIdentifier.label')
          readonly: false,
          options: [
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.edit.dialog.form.packagingIdentifier.options.disposablePackaging',
              ), // t('masterDataManagement.packagingData.table.edit.dialog.form.packagingIdentifier.options.disposablePackaging')
              code: 'disposablePackaging',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.edit.dialog.form.packagingIdentifier.options.reusablePackaging',
              ), // t('masterDataManagement.packagingData.table.edit.dialog.form.packagingIdentifier.options.reusablePackaging')
              code: 'reusablePackaging',
            },
          ],
          validation: {
            isRequired: false,
          },
        },
        // PropertyIdentifier
        propertyIdentifier: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.edit.dialog.form.propertyIdentifier.label',
          ), // t('masterDataManagement.packagingData.table.edit.dialog.form.propertyIdentifier.label')
          readonly: false,
          options: [
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.edit.dialog.form.propertyIdentifier.options.customer',
              ), // t('masterDataManagement.packagingData.table.edit.dialog.form.propertyIdentifier.options.customer')
              code: 'customer',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.edit.dialog.form.propertyIdentifier.options.supplier',
              ), // t('masterDataManagement.packagingData.table.edit.dialog.form.propertyIdentifier.options.supplier')
              code: 'supplier',
            },
            {
              name: getTranslationsForConfig(
                'masterDataManagement.packagingData.table.edit.dialog.form.propertyIdentifier.options.thirdParties',
              ), // t('masterDataManagement.packagingData.table.edit.dialog.form.propertyIdentifier.options.thirdParties')
              code: 'thirdParties',
            },
          ],
          validation: {
            isRequired: false,
          },
        },
        // IsStackable
        isStackable: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.packagingData.table.edit.dialog.form.isStackable.label',
          ), // t('masterDataManagement.packagingData.table.edit.dialog.form.isStackable.label')
          readonly: true,
          validation: {
            isRequired: false,
          },
        },
      },
    },
    // 2 companyCodes
    companyCodes: {
      table: {
        enabled: true,
        columns: [
          {
            // IsStandard
            field: 'IsStandard',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'masterDataManagement.companyCodes.table.columns.isStandard.filterPlaceholder',
            ), // t('masterDataManagement.companyCodes.table.columns.isStandard.filterPlaceholder')
            header: getTranslationsForConfig(
              'masterDataManagement.companyCodes.table.columns.isStandard.header',
            ), // t('masterDataManagement.companyCodes.table.columns.isStandard.header')
            sortable: true,
          },
          {
            // DisplayId
            field: 'Common.DisplayId',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'masterDataManagement.companyCodes.table.columns.displayId.filterPlaceholder',
            ), // t('masterDataManagement.companyCodes.table.columns.displayId.filterPlaceholder')
            header: getTranslationsForConfig(
              'masterDataManagement.companyCodes.table.columns.displayId.header',
            ), // t('masterDataManagement.companyCodes.table.columns.displayId.header')
            sortable: true,
          },
          {
            // Company
            field: 'Common.Company',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'masterDataManagement.companyCodes.table.columns.company.filterPlaceholder',
            ), // t('masterDataManagement.companyCodes.table.columns.company.filterPlaceholder')
            header: getTranslationsForConfig(
              'masterDataManagement.companyCodes.table.columns.company.header',
            ), // t('masterDataManagement.companyCodes.table.columns.company.header')
            sortable: true,
          },
          {
            // SalesTaxID
            field: 'Common.SalesTaxID',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'masterDataManagement.companyCodes.table.columns.salesTaxID.filterPlaceholder',
            ), // t('masterDataManagement.companyCodes.table.columns.salesTaxID.filterPlaceholder')
            header: getTranslationsForConfig(
              'masterDataManagement.companyCodes.table.columns.salesTaxID.header',
            ), // t('masterDataManagement.companyCodes.table.columns.salesTaxID.header')
            sortable: true,
          },
          {
            // Street
            field: 'Address.Street',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'masterDataManagement.companyCodes.table.columns.street.filterPlaceholder',
            ), // t('masterDataManagement.companyCodes.table.columns.street.filterPlaceholder')
            header: getTranslationsForConfig(
              'masterDataManagement.companyCodes.table.columns.street.header',
            ), // t('masterDataManagement.companyCodes.table.columns.street.header')
            sortable: true,
          },
          {
            // PostalCode
            field: 'Address.PostalCode',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'masterDataManagement.companyCodes.table.columns.postalCode.filterPlaceholder',
            ), // t('masterDataManagement.companyCodes.table.columns.postalCode.filterPlaceholder')
            header: getTranslationsForConfig(
              'masterDataManagement.companyCodes.table.columns.postalCode.header',
            ), // t('masterDataManagement.companyCodes.table.columns.postalCode.header')
            sortable: true,
          },
          {
            // City
            field: 'Address.City',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'masterDataManagement.companyCodes.table.columns.city.filterPlaceholder',
            ), // t('masterDataManagement.companyCodes.table.columns.city.filterPlaceholder')
            header: getTranslationsForConfig(
              'masterDataManagement.companyCodes.table.columns.city.header',
            ), // t('masterDataManagement.companyCodes.table.columns.city.header')
            sortable: true,
          },
          {
            // Country
            field: 'Address.Country',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'masterDataManagement.companyCodes.table.columns.country.filterPlaceholder',
            ), // t('masterDataManagement.companyCodes.table.columns.country.filterPlaceholder')
            header: getTranslationsForConfig(
              'masterDataManagement.companyCodes.table.columns.country.header',
            ), // t('masterDataManagement.companyCodes.table.columns.country.header')
            sortable: true,
          },
        ],
        emptyMessageDetails: getTranslationsForConfig(
          'masterDataManagement.companyCodes.table.emptyMessageDetails',
        ), // t('masterDataManagement.companyCodes.table.emptyMessageDetails')
        emptyMessageTitle: getTranslationsForConfig(
          'masterDataManagement.companyCodes.table.emptyMessageTitle',
        ), // t('masterDataManagement.companyCodes.table.emptyMessageTitle')
        paginator: true,
        rows: 20,
        rowsPerPageOptions: [20, 50, 100],
        sortField: 'Common.DisplayId',
        sortOrder: 1,
      },
      // 2.1 Add
      add: {
        enabled: true,
        displayId: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.companyCodes.table.dialog.form.billingInformation.id.label',
          ), // t('masterDataManagement.companyCodes.table.dialog.form.billingInformation.id.label')
          validation: {
            isRequired: true,
          },
        },
        company: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.companyCodes.table.dialog.form.billingInformation.company.label',
          ), // t('masterDataManagement.companyCodes.table.dialog.form.billingInformation.company.label')
          readonly: false,
          validation: {
            isRequired: true,
          },
        },
        taxNumber: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.companyCodes.table.dialog.form.billingInformation.taxNumber.label',
          ), // t('masterDataManagement.companyCodes.table.dialog.form.billingInformation.taxNumber.label')
          readonly: false,
        },
        salesTaxID: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.companyCodes.table.dialog.form.billingInformation.vatId.label',
          ), // t('masterDataManagement.companyCodes.table.dialog.form.billingInformation.vatId.label')
          readonly: false,
        },
        street: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.companyCodes.table.dialog.form.billingAddress.street.label',
          ), // t('masterDataManagement.companyCodes.table.dialog.form.billingAddress.street.label')
          readonly: false,
        },
        postalCode: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.companyCodes.table.dialog.form.billingAddress.postalCode.label',
          ), // t('masterDataManagement.companyCodes.table.dialog.form.billingAddress.postalCode.label')
          readonly: false,
        },
        city: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.companyCodes.table.dialog.form.billingAddress.city.label',
          ), // t('masterDataManagement.companyCodes.table.dialog.form.billingAddress.city.label')
          readonly: false,
        },
        country: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.companyCodes.table.dialog.form.billingAddress.country.label',
          ), // t('masterDataManagement.companyCodes.table.dialog.form.billingAddress.country.label')
        },
        additionalProperties: {
          key: {
            enabled: true,
            label: getTranslationsForConfig(
              'masterDataManagement.companyCodes.table.dialog.form.additionalProperties.table.columns.name.header',
            ), // t('masterDataManagement.companyCodes.table.dialog.form.additionalProperties.table.columns.name.header')
            validation: {
              isRequired: true,
            },
          },
          value: {
            enabled: true,
            label: getTranslationsForConfig(
              'masterDataManagement.companyCodes.table.dialog.form.additionalProperties.table.columns.value.header',
            ), // t('masterDataManagement.companyCodes.table.dialog.form.additionalProperties.table.columns.value.header')
            validation: {
              isRequired: true,
            },
          },
          table: {
            enabled: true,
            columns: [
              {
                // Name
                field: 'CustomFieldDefinition.Key',
                header: getTranslationsForConfig(
                  'masterDataManagement.companyCodes.table.dialog.form.additionalProperties.table.columns.name.header',
                ), // t('masterDataManagement.companyCodes.table.dialog.form.additionalProperties.table.columns.name.header')
              },
              {
                // Value
                field: 'Value',
                header: getTranslationsForConfig(
                  'masterDataManagement.companyCodes.table.dialog.form.additionalProperties.table.columns.value.header',
                ), // t('masterDataManagement.companyCodes.table.dialog.form.additionalProperties.table.columns.value.header')
              },
            ],
            emptyMessageDetails: getTranslationsForConfig(
              'masterDataManagement.companyCodes.table.dialog.form.additionalProperties.table.emptyMessageDetails',
            ), // t('masterDataManagement.companyCodes.table.dialog.form.additionalProperties.table.emptyMessageDetails')
            emptyMessageTitle: getTranslationsForConfig(
              'masterDataManagement.companyCodes.table.dialog.form.additionalProperties.table.emptyMessageTitle',
            ), // t('masterDataManagement.companyCodes.table.dialog.form.additionalProperties.table.emptyMessageTitle')
            paginator: true,
            rows: 20,
            rowsPerPageOptions: [20, 50, 100],
          },
        },
      },
      // 2.2 Info
      info: {
        enabled: true,
        displayId: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.companyCodes.table.dialog.form.billingInformation.id.label',
          ), // t('masterDataManagement.companyCodes.table.dialog.form.billingInformation.id.label')
        },
        company: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.companyCodes.table.dialog.form.billingInformation.company.label',
          ), // t('masterDataManagement.companyCodes.table.dialog.form.billingInformation.company.label')
        },
        taxNumber: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.companyCodes.table.dialog.form.billingInformation.taxNumber.label',
          ), // t('masterDataManagement.companyCodes.table.dialog.form.billingInformation.taxNumber.label')
        },
        salesTaxID: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.companyCodes.table.dialog.form.billingInformation.vatId.label',
          ), // t('masterDataManagement.companyCodes.table.dialog.form.billingInformation.vatId.label')
        },
        street: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.companyCodes.table.dialog.form.billingAddress.street.label',
          ), // t('masterDataManagement.companyCodes.table.dialog.form.billingAddress.street.label')
        },
        postalCode: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.companyCodes.table.dialog.form.billingAddress.postalCode.label',
          ), // t('masterDataManagement.companyCodes.table.dialog.form.billingAddress.postalCode.label')
        },
        city: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.companyCodes.table.dialog.form.billingAddress.city.label',
          ), // t('masterDataManagement.companyCodes.table.dialog.form.billingAddress.city.label')
        },
        country: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.companyCodes.table.dialog.form.billingAddress.country.label',
          ), // t('masterDataManagement.companyCodes.table.dialog.form.billingAddress.country.label')
        },
        additionalProperties: {
          key: {
            enabled: true,
            label: getTranslationsForConfig(
              'masterDataManagement.companyCodes.table.dialog.form.additionalProperties.table.columns.name.header',
            ), // t('masterDataManagement.companyCodes.table.dialog.form.additionalProperties.table.columns.name.header')
          },
          value: {
            enabled: true,
            label: getTranslationsForConfig(
              'masterDataManagement.companyCodes.table.dialog.form.additionalProperties.table.columns.value.header',
            ), // t('masterDataManagement.companyCodes.table.dialog.form.additionalProperties.table.columns.value.header')
          },
          table: {
            enabled: true,
            columns: [
              {
                // Name
                field: 'CustomFieldDefinition.Key',
                header: getTranslationsForConfig(
                  'masterDataManagement.companyCodes.table.dialog.form.additionalProperties.table.columns.name.header',
                ), // t('masterDataManagement.companyCodes.table.dialog.form.additionalProperties.table.columns.name.header')
              },
              {
                // Value
                field: 'Value',
                header: getTranslationsForConfig(
                  'masterDataManagement.companyCodes.table.dialog.form.additionalProperties.table.columns.value.header',
                ), // t('masterDataManagement.companyCodes.table.dialog.form.additionalProperties.table.columns.value.header')
              },
            ],
            emptyMessageDetails: getTranslationsForConfig(
              'masterDataManagement.companyCodes.table.dialog.form.additionalProperties.table.emptyMessageDetails',
            ), // t('masterDataManagement.companyCodes.table.dialog.form.additionalProperties.table.emptyMessageDetails')
            emptyMessageTitle: getTranslationsForConfig(
              'masterDataManagement.companyCodes.table.dialog.form.additionalProperties.table.emptyMessageTitle',
            ), // t('masterDataManagement.companyCodes.table.dialog.form.additionalProperties.table.emptyMessageTitle')
            paginator: true,
            rows: 20,
            rowsPerPageOptions: [20, 50, 100],
          },
        },
      },
      // 2.3 Edit
      edit: {
        enabled: true,
        displayId: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.companyCodes.table.dialog.form.billingInformation.id.label',
          ), // t('masterDataManagement.companyCodes.table.dialog.form.billingInformation.id.label')
          validation: {
            isRequired: true,
          },
        },
        company: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.companyCodes.table.dialog.form.billingInformation.company.label',
          ), // t('masterDataManagement.companyCodes.table.dialog.form.billingInformation.company.label')
          readonly: false,
          validation: {
            isRequired: true,
          },
        },
        taxNumber: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.companyCodes.table.dialog.form.billingInformation.taxNumber.label',
          ), // t('masterDataManagement.companyCodes.table.dialog.form.billingInformation.taxNumber.label')
          readonly: false,
        },
        salesTaxID: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.companyCodes.table.dialog.form.billingInformation.vatId.label',
          ), // t('masterDataManagement.companyCodes.table.dialog.form.billingInformation.vatId.label')
          readonly: false,
        },
        street: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.companyCodes.table.dialog.form.billingAddress.street.label',
          ), // t('masterDataManagement.companyCodes.table.dialog.form.billingAddress.street.label')
          readonly: false,
        },
        postalCode: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.companyCodes.table.dialog.form.billingAddress.postalCode.label',
          ), // t('masterDataManagement.companyCodes.table.dialog.form.billingAddress.postalCode.label')
          readonly: false,
        },
        city: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.companyCodes.table.dialog.form.billingAddress.city.label',
          ), // t('masterDataManagement.companyCodes.table.dialog.form.billingAddress.city.label')
          readonly: false,
        },
        country: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.companyCodes.table.dialog.form.billingAddress.country.label',
          ), // t('masterDataManagement.companyCodes.table.dialog.form.billingAddress.country.label')
        },
        additionalProperties: {
          key: {
            enabled: true,
            label: getTranslationsForConfig(
              'masterDataManagement.companyCodes.table.dialog.form.additionalProperties.table.columns.name.header',
            ), // t('masterDataManagement.companyCodes.table.dialog.form.additionalProperties.table.columns.name.header')
            validation: {
              isRequired: true,
            },
          },
          value: {
            enabled: true,
            label: getTranslationsForConfig(
              'masterDataManagement.companyCodes.table.dialog.form.additionalProperties.table.columns.value.header',
            ), // t('masterDataManagement.companyCodes.table.dialog.form.additionalProperties.table.columns.value.header')
            validation: {
              isRequired: true,
            },
          },
          table: {
            enabled: true,
            columns: [
              {
                // Name
                field: 'CustomFieldDefinition.Key',
                header: getTranslationsForConfig(
                  'masterDataManagement.companyCodes.table.dialog.form.additionalProperties.table.columns.name.header',
                ), // t('masterDataManagement.companyCodes.table.dialog.form.additionalProperties.table.columns.name.header')
              },
              {
                // Value
                field: 'Value',
                header: getTranslationsForConfig(
                  'masterDataManagement.companyCodes.table.dialog.form.additionalProperties.table.columns.value.header',
                ), // t('masterDataManagement.companyCodes.table.dialog.form.additionalProperties.table.columns.value.header')
              },
            ],
            emptyMessageDetails: getTranslationsForConfig(
              'masterDataManagement.companyCodes.table.dialog.form.additionalProperties.table.emptyMessageDetails',
            ), // t('masterDataManagement.companyCodes.table.dialog.form.additionalProperties.table.emptyMessageDetails')
            emptyMessageTitle: getTranslationsForConfig(
              'masterDataManagement.companyCodes.table.dialog.form.additionalProperties.table.emptyMessageTitle',
            ), // t('masterDataManagement.companyCodes.table.dialog.form.additionalProperties.table.emptyMessageTitle')
            paginator: true,
            rows: 20,
            rowsPerPageOptions: [20, 50, 100],
          },
        },
      },
    },
    // 3 suppliers
    suppliers: {
      table: {
        enabled: true,
        columns: [
          {
            // Id
            field: 'Common.DisplayId',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'masterDataManagement.suppliers.table.columns.id.filterPlaceholder',
            ), // t('masterDataManagement.suppliers.table.columns.id.filterPlaceholder')
            header: getTranslationsForConfig(
              'masterDataManagement.suppliers.table.columns.id.header',
            ), // t('masterDataManagement.suppliers.table.columns.id.header')
            sortable: true,
          },
          {
            // Company
            field: 'Common.Company',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'masterDataManagement.suppliers.table.columns.company.filterPlaceholder',
            ), // t('masterDataManagement.suppliers.table.columns.company.filterPlaceholder')
            header: getTranslationsForConfig(
              'masterDataManagement.suppliers.table.columns.company.header',
            ), // t('masterDataManagement.suppliers.table.columns.company.header')
            sortable: true,
          },
          {
            // Tax number
            field: 'Common.TaxNumber',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'masterDataManagement.suppliers.table.columns.taxNumber.filterPlaceholder',
            ), // t('masterDataManagement.suppliers.table.columns.taxNumber.filterPlaceholder')
            header: getTranslationsForConfig(
              'masterDataManagement.suppliers.table.columns.taxNumber.header',
            ), // t('masterDataManagement.suppliers.table.columns.taxNumber.header')
            sortable: true,
          },
          {
            // Vat id
            field: 'Common.SalesTaxID',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'masterDataManagement.suppliers.table.columns.vatId.filterPlaceholder',
            ), // t('masterDataManagement.suppliers.table.columns.vatId.filterPlaceholder')
            header: getTranslationsForConfig(
              'masterDataManagement.suppliers.table.columns.vatId.header',
            ), // t('masterDataManagement.suppliers.table.columns.vatId.header')
            sortable: true,
          },
          {
            // Street
            field: 'Address.Street',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'masterDataManagement.suppliers.table.columns.street.filterPlaceholder',
            ), // t('masterDataManagement.suppliers.table.columns.street.filterPlaceholder')
            header: getTranslationsForConfig(
              'masterDataManagement.suppliers.table.columns.street.header',
            ), // t('masterDataManagement.suppliers.table.columns.street.header')
            sortable: true,
          },
          {
            // Postal code
            field: 'Address.PostalCode',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'masterDataManagement.suppliers.table.columns.postalCode.filterPlaceholder',
            ), // t('masterDataManagement.suppliers.table.columns.postalCode.filterPlaceholder')
            header: getTranslationsForConfig(
              'masterDataManagement.suppliers.table.columns.postalCode.header',
            ), // t('masterDataManagement.suppliers.table.columns.postalCode.header')
            sortable: true,
          },
          {
            // City
            field: 'Address.City',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'masterDataManagement.suppliers.table.columns.city.filterPlaceholder',
            ), // t('masterDataManagement.suppliers.table.columns.city.filterPlaceholder')
            header: getTranslationsForConfig(
              'masterDataManagement.suppliers.table.columns.city.header',
            ), // t('masterDataManagement.suppliers.table.columns.city.header')
            sortable: true,
          },
          {
            // Country
            field: 'Address.Country',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'masterDataManagement.suppliers.table.columns.country.filterPlaceholder',
            ), // t('masterDataManagement.suppliers.table.columns.country.filterPlaceholder')
            header: getTranslationsForConfig(
              'masterDataManagement.suppliers.table.columns.country.header',
            ), // t('masterDataManagement.suppliers.table.columns.country.header')
            sortable: true,
          },
          {
            // Company codes
            field: 'CompanyCodes',
            filter: true,
            filterPlaceholder: getTranslationsForConfig(
              'masterDataManagement.suppliers.table.columns.companyCodes.filterPlaceholder',
            ), // t('masterDataManagement.suppliers.table.columns.companyCodes.filterPlaceholder')
            header: getTranslationsForConfig(
              'masterDataManagement.suppliers.table.columns.companyCodes.header',
            ), // t('masterDataManagement.suppliers.table.columns.companyCodes.header')
            sortable: true,
          },
          {
            // Cockpit status
            field: 'CockpitStatus',
            filter: true,
            header: getTranslationsForConfig(
              'masterDataManagement.suppliers.table.columns.cockpitStatus.header',
            ), // t('masterDataManagement.suppliers.table.columns.cockpitStatus.header')
            sortable: true,
          },
        ],
        emptyMessageDetails: getTranslationsForConfig(
          'masterDataManagement.suppliers.table.emptyMessageDetails',
        ), // t('masterDataManagement.suppliers.table.emptyMessageDetails')
        emptyMessageTitle: getTranslationsForConfig(
          'masterDataManagement.suppliers.table.emptyMessageTitle',
        ), // t('masterDataManagement.suppliers.table.emptyMessageTitle')
        paginator: true,
        rows: 20,
        rowsPerPageOptions: [20, 50, 100],
        sortField: 'common.displayId',
        sortOrder: 1,
      },
      // 3.1 Add
      add: {
        enabled: true,
        companySelection: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.suppliers.table.dialog.form.billingInformation.companySelection.label',
          ), // t('masterDataManagement.suppliers.table.dialog.form.billingInformation.companySelection.label')
          placeholder: getTranslationsForConfig(
            'masterDataManagement.suppliers.table.dialog.form.billingInformation.companySelection.placeholder',
          ), // t('masterDataManagement.suppliers.table.dialog.form.billingInformation.companySelection.placeholder')
        },
        displayId: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.suppliers.table.dialog.form.billingInformation.id.label',
          ), // t('masterDataManagement.suppliers.table.dialog.form.billingInformation.id.label')
          validation: {
            isRequired: true,
          },
        },
        company: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.suppliers.table.dialog.form.billingInformation.company.label',
          ), // t('masterDataManagement.suppliers.table.dialog.form.billingInformation.company.label')
          readonly: false,
          validation: {
            isRequired: true,
          },
        },
        taxNumber: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.suppliers.table.dialog.form.billingInformation.taxNumber.label',
          ), // t('masterDataManagement.suppliers.table.dialog.form.billingInformation.taxNumber.label')
          readonly: false,
        },
        salesTaxID: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.suppliers.table.dialog.form.billingInformation.salesTaxID.label',
          ), // t('masterDataManagement.suppliers.table.dialog.form.billingInformation.salesTaxID.label')
          readonly: false,
        },
        street: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.suppliers.table.dialog.form.billingAddress.street.label',
          ), // t('masterDataManagement.suppliers.table.dialog.form.billingAddress.street.label')
          readonly: false,
        },
        postalCode: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.suppliers.table.dialog.form.billingAddress.postalCode.label',
          ), // t('masterDataManagement.suppliers.table.dialog.form.billingAddress.postalCode.label')
          readonly: false,
        },
        city: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.suppliers.table.dialog.form.billingAddress.city.label',
          ), // t('masterDataManagement.suppliers.table.dialog.form.billingAddress.city.label')
          readonly: false,
        },
        country: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.suppliers.table.dialog.form.billingAddress.country.label',
          ), // t('masterDataManagement.suppliers.table.dialog.form.billingAddress.country.label')
        },
        assignedCompanyCodes: {
          identifier: {
            enabled: true,
            label: getTranslationsForConfig(
              'masterDataManagement.suppliers.table.dialog.form.assignedCompanyCodes.table.columns.identifier.header',
            ), // t('masterDataManagement.suppliers.table.dialog.form.assignedCompanyCodes.table.columns.identifier.header')
            validation: {
              isRequired: true,
            },
          },
          company: {
            enabled: true,
            label: getTranslationsForConfig(
              'masterDataManagement.suppliers.table.dialog.form.assignedCompanyCodes.table.columns.company.header',
            ), // t('masterDataManagement.suppliers.table.dialog.form.assignedCompanyCodes.table.columns.company.header')
            validation: {
              isRequired: true,
            },
          },
          table: {
            enabled: true,
            columns: [
              {
                // Identifier
                field: 'Common.DisplayId',
                header: getTranslationsForConfig(
                  'masterDataManagement.suppliers.table.dialog.form.assignedCompanyCodes.table.columns.identifier.header',
                ), // t('masterDataManagement.suppliers.table.dialog.form.assignedCompanyCodes.table.columns.identifier.header')
                width: '35%',
              },
              {
                // Company
                field: 'Common.Company',
                header: getTranslationsForConfig(
                  'masterDataManagement.suppliers.table.dialog.form.assignedCompanyCodes.table.columns.company.header',
                ), // t('masterDataManagement.suppliers.table.dialog.form.assignedCompanyCodes.table.columns.company.header')
                width: '35%',
              },
            ],
            emptyMessageDetails: getTranslationsForConfig(
              'masterDataManagement.suppliers.table.dialog.form.assignedCompanyCodes.table.emptyMessageDetails',
            ), // t('masterDataManagement.suppliers.table.dialog.form.assignedCompanyCodes.table.emptyMessageDetails')
            emptyMessageTitle: getTranslationsForConfig(
              'masterDataManagement.suppliers.table.dialog.form.assignedCompanyCodes.table.emptyMessageTitle',
            ), // t('masterDataManagement.suppliers.table.dialog.form.assignedCompanyCodes.table.emptyMessageTitle')
            paginator: true,
            rows: 20,
            rowsPerPageOptions: [20, 50, 100],
          },
        },
        additionalProperties: {
          key: {
            enabled: true,
            label: getTranslationsForConfig(
              'masterDataManagement.suppliers.table.dialog.form.additionalProperties.table.columns.name.header',
            ), // t('masterDataManagement.suppliers.table.dialog.form.additionalProperties.table.columns.name.header')
            validation: {
              isRequired: true,
            },
          },
          value: {
            enabled: true,
            label: getTranslationsForConfig(
              'masterDataManagement.suppliers.table.dialog.form.additionalProperties.table.columns.value.header',
            ), // t('masterDataManagement.suppliers.table.dialog.form.additionalProperties.table.columns.value.header')
            validation: {
              isRequired: true,
            },
          },
          table: {
            enabled: true,
            columns: [
              {
                // Name
                field: 'CustomFieldDefinition.Key',
                header: getTranslationsForConfig(
                  'masterDataManagement.suppliers.table.dialog.form.additionalProperties.table.columns.name.header',
                ), // t('masterDataManagement.suppliers.table.dialog.form.additionalProperties.table.columns.name.header')
              },
              {
                // Value
                field: 'Value',
                header: getTranslationsForConfig(
                  'masterDataManagement.suppliers.table.dialog.form.additionalProperties.table.columns.value.header',
                ), // t('masterDataManagement.suppliers.table.dialog.form.additionalProperties.table.columns.value.header')
              },
            ],
            emptyMessageDetails: getTranslationsForConfig(
              'masterDataManagement.suppliers.table.dialog.form.additionalProperties.table.emptyMessageDetails',
            ), // t('masterDataManagement.suppliers.table.dialog.form.additionalProperties.table.emptyMessageDetails')
            emptyMessageTitle: getTranslationsForConfig(
              'masterDataManagement.suppliers.table.dialog.form.additionalProperties.table.emptyMessageTitle',
            ), // t('masterDataManagement.suppliers.table.dialog.form.additionalProperties.table.emptyMessageTitle')
            paginator: true,
            rows: 20,
            rowsPerPageOptions: [20, 50, 100],
          },
        },
      },
      // 3.2 Info
      info: {
        enabled: true,
        companySelection: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.suppliers.table.dialog.form.billingInformation.companySelection.label',
          ), // t('masterDataManagement.suppliers.table.dialog.form.billingInformation.companySelection.label')
        },
        displayId: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.suppliers.table.dialog.form.billingInformation.id.label',
          ), // t('masterDataManagement.suppliers.table.dialog.form.billingInformation.id.label')
        },
        company: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.suppliers.table.dialog.form.billingInformation.company.label',
          ), // t('masterDataManagement.suppliers.table.dialog.form.billingInformation.company.label')
        },
        taxNumber: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.suppliers.table.dialog.form.billingInformation.taxNumber.label',
          ), // t('masterDataManagement.suppliers.table.dialog.form.billingInformation.taxNumber.label')
        },
        salesTaxID: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.suppliers.table.dialog.form.billingInformation.salesTaxID.label',
          ), // t('masterDataManagement.suppliers.table.dialog.form.billingInformation.salesTaxID.label')
        },
        street: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.suppliers.table.dialog.form.billingAddress.street.label',
          ), // t('masterDataManagement.suppliers.table.dialog.form.billingAddress.street.label')
        },
        postalCode: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.suppliers.table.dialog.form.billingAddress.postalCode.label',
          ), // t('masterDataManagement.suppliers.table.dialog.form.billingAddress.postalCode.label')
        },
        city: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.suppliers.table.dialog.form.billingAddress.city.label',
          ), // t('masterDataManagement.suppliers.table.dialog.form.billingAddress.city.label')
        },
        country: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.suppliers.table.dialog.form.billingAddress.country.label',
          ), // t('masterDataManagement.suppliers.table.dialog.form.billingAddress.country.label')
        },
        assignedCompanyCodes: {
          identifier: {
            enabled: true,
            label: getTranslationsForConfig(
              'masterDataManagement.suppliers.table.dialog.form.assignedCompanyCodes.table.columns.identifier.header',
            ), // t('masterDataManagement.suppliers.table.dialog.form.assignedCompanyCodes.table.columns.identifier.header')
          },
          company: {
            enabled: true,
            label: getTranslationsForConfig(
              'masterDataManagement.suppliers.table.dialog.form.assignedCompanyCodes.table.columns.company.header',
            ), // t('masterDataManagement.suppliers.table.dialog.form.assignedCompanyCodes.table.columns.company.header')
          },
          table: {
            enabled: true,
            columns: [
              {
                // Identifier
                field: 'Common.DisplayId',
                header: getTranslationsForConfig(
                  'masterDataManagement.suppliers.table.dialog.form.assignedCompanyCodes.table.columns.identifier.header',
                ), // t('masterDataManagement.suppliers.table.dialog.form.assignedCompanyCodes.table.columns.identifier.header')
                width: '35%',
              },
              {
                // Company
                field: 'Common.Company',
                header: getTranslationsForConfig(
                  'masterDataManagement.suppliers.table.dialog.form.assignedCompanyCodes.table.columns.company.header',
                ), // t('masterDataManagement.suppliers.table.dialog.form.assignedCompanyCodes.table.columns.company.header')
                width: '35%',
              },
            ],
            emptyMessageDetails: getTranslationsForConfig(
              'masterDataManagement.suppliers.table.dialog.form.assignedCompanyCodes.table.emptyMessageDetails',
            ), // t('masterDataManagement.suppliers.table.dialog.form.assignedCompanyCodes.table.emptyMessageDetails')
            emptyMessageTitle: getTranslationsForConfig(
              'masterDataManagement.suppliers.table.dialog.form.assignedCompanyCodes.table.emptyMessageTitle',
            ), // t('masterDataManagement.suppliers.table.dialog.form.assignedCompanyCodes.table.emptyMessageTitle')
            paginator: true,
            rows: 20,
            rowsPerPageOptions: [20, 50, 100],
          },
        },
        additionalProperties: {
          key: {
            enabled: true,
            label: getTranslationsForConfig(
              'masterDataManagement.suppliers.table.dialog.form.additionalProperties.table.columns.name.header',
            ), // t('masterDataManagement.suppliers.table.dialog.form.additionalProperties.table.columns.name.header')
          },
          value: {
            enabled: true,
            label: getTranslationsForConfig(
              'masterDataManagement.suppliers.table.dialog.form.additionalProperties.table.columns.value.header',
            ), // t('masterDataManagement.suppliers.table.dialog.form.additionalProperties.table.columns.value.header')
          },
          table: {
            enabled: true,
            columns: [
              {
                // Name
                field: 'CustomFieldDefinition.Key',
                header: getTranslationsForConfig(
                  'masterDataManagement.suppliers.table.dialog.form.additionalProperties.table.columns.name.header',
                ), // t('masterDataManagement.suppliers.table.dialog.form.additionalProperties.table.columns.name.header')
              },
              {
                // Value
                field: 'Value',
                header: getTranslationsForConfig(
                  'masterDataManagement.suppliers.table.dialog.form.additionalProperties.table.columns.value.header',
                ), // t('masterDataManagement.suppliers.table.dialog.form.additionalProperties.table.columns.value.header')
              },
            ],
            emptyMessageDetails: getTranslationsForConfig(
              'masterDataManagement.suppliers.table.dialog.form.additionalProperties.table.emptyMessageDetails',
            ), // t('masterDataManagement.suppliers.table.dialog.form.additionalProperties.table.emptyMessageDetails')
            emptyMessageTitle: getTranslationsForConfig(
              'masterDataManagement.suppliers.table.dialog.form.additionalProperties.table.emptyMessageTitle',
            ), // t('masterDataManagement.suppliers.table.dialog.form.additionalProperties.table.emptyMessageTitle')
            paginator: true,
            rows: 20,
            rowsPerPageOptions: [20, 50, 100],
          },
        },
      },
      // 3.3 Edit
      edit: {
        enabled: true,
        companySelection: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.suppliers.table.dialog.form.billingInformation.companySelection.label',
          ), // t('masterDataManagement.suppliers.table.dialog.form.billingInformation.company.label')
          placeholder: getTranslationsForConfig(
            'masterDataManagement.suppliers.table.dialog.form.billingInformation.companySelection.placeholder',
          ), // t('masterDataManagement.suppliers.table.dialog.form.billingInformation.companySelection.placeholder')
        },
        displayId: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.suppliers.table.dialog.form.billingInformation.id.label',
          ), // t('masterDataManagement.suppliers.table.dialog.form.billingInformation.id.label')
          validation: {
            isRequired: true,
          },
        },
        company: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.suppliers.table.dialog.form.billingInformation.company.label',
          ), // t('masterDataManagement.suppliers.table.dialog.form.billingInformation.company.label')
          readonly: false,
          validation: {
            isRequired: true,
          },
        },
        taxNumber: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.suppliers.table.dialog.form.billingInformation.taxNumber.label',
          ), // t('masterDataManagement.suppliers.table.dialog.form.billingInformation.taxNumber.label')
          readonly: false,
        },
        salesTaxID: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.suppliers.table.dialog.form.billingInformation.salesTaxID.label',
          ), // t('masterDataManagement.suppliers.table.dialog.form.billingInformation.salesTaxID.label')
          readonly: false,
        },
        street: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.suppliers.table.dialog.form.billingAddress.street.label',
          ), // t('masterDataManagement.suppliers.table.dialog.form.billingAddress.street.label')
          readonly: false,
        },
        postalCode: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.suppliers.table.dialog.form.billingAddress.postalCode.label',
          ), // t('masterDataManagement.suppliers.table.dialog.form.billingAddress.postalCode.label')
          readonly: false,
        },
        city: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.suppliers.table.dialog.form.billingAddress.city.label',
          ), // t('masterDataManagement.suppliers.table.dialog.form.billingAddress.city.label')
          readonly: false,
        },
        country: {
          enabled: true,
          label: getTranslationsForConfig(
            'masterDataManagement.suppliers.table.dialog.form.billingAddress.country.label',
          ), // t('masterDataManagement.suppliers.table.dialog.form.billingAddress.country.label')
        },
        assignedCompanyCodes: {
          identifier: {
            enabled: true,
            label: getTranslationsForConfig(
              'masterDataManagement.suppliers.table.dialog.form.assignedCompanyCodes.table.columns.identifier.header',
            ), // t('masterDataManagement.suppliers.table.dialog.form.assignedCompanyCodes.table.columns.identifier.header')
            validation: {
              isRequired: true,
            },
          },
          company: {
            enabled: true,
            label: getTranslationsForConfig(
              'masterDataManagement.suppliers.table.dialog.form.assignedCompanyCodes.table.columns.company.header',
            ), // t('masterDataManagement.suppliers.table.dialog.form.assignedCompanyCodes.table.columns.company.header')
            validation: {
              isRequired: true,
            },
          },
          table: {
            enabled: true,
            columns: [
              {
                // Identifier
                field: 'Common.DisplayId',
                header: getTranslationsForConfig(
                  'masterDataManagement.suppliers.table.dialog.form.assignedCompanyCodes.table.columns.identifier.header',
                ), // t('masterDataManagement.suppliers.table.dialog.form.assignedCompanyCodes.table.columns.identifier.header')
                width: '35%',
              },
              {
                // Company
                field: 'Common.Company',
                header: getTranslationsForConfig(
                  'masterDataManagement.suppliers.table.dialog.form.assignedCompanyCodes.table.columns.company.header',
                ), // t('masterDataManagement.suppliers.table.dialog.form.assignedCompanyCodes.table.columns.company.header')
                width: '35%',
              },
            ],
            emptyMessageDetails: getTranslationsForConfig(
              'masterDataManagement.suppliers.table.dialog.form.assignedCompanyCodes.table.emptyMessageDetails',
            ), // t('masterDataManagement.suppliers.table.dialog.form.assignedCompanyCodes.table.emptyMessageDetails')
            emptyMessageTitle: getTranslationsForConfig(
              'masterDataManagement.suppliers.table.dialog.form.assignedCompanyCodes.table.emptyMessageTitle',
            ), // t('masterDataManagement.suppliers.table.dialog.form.assignedCompanyCodes.table.emptyMessageTitle')
            paginator: true,
            rows: 20,
            rowsPerPageOptions: [20, 50, 100],
          },
        },
        additionalProperties: {
          key: {
            enabled: true,
            label: getTranslationsForConfig(
              'masterDataManagement.suppliers.table.dialog.form.additionalProperties.table.columns.name.header',
            ), // t('masterDataManagement.suppliers.table.dialog.form.additionalProperties.table.columns.name.header')
            validation: {
              isRequired: true,
            },
          },
          value: {
            enabled: true,
            label: getTranslationsForConfig(
              'masterDataManagement.suppliers.table.dialog.form.additionalProperties.table.columns.value.header',
            ), // t('masterDataManagement.suppliers.table.dialog.form.additionalProperties.table.columns.value.header')
            validation: {
              isRequired: true,
            },
          },
          table: {
            enabled: true,
            columns: [
              {
                // Name
                field: 'CustomFieldDefinition.Key',
                header: getTranslationsForConfig(
                  'masterDataManagement.suppliers.table.dialog.form.additionalProperties.table.columns.name.header',
                ), // t('masterDataManagement.suppliers.table.dialog.form.additionalProperties.table.columns.name.header')
              },
              {
                // Value
                field: 'Value',
                header: getTranslationsForConfig(
                  'masterDataManagement.suppliers.table.dialog.form.additionalProperties.table.columns.value.header',
                ), // t('masterDataManagement.suppliers.table.dialog.form.additionalProperties.table.columns.value.header')
              },
            ],
            emptyMessageDetails: getTranslationsForConfig(
              'masterDataManagement.suppliers.table.dialog.form.additionalProperties.table.emptyMessageDetails',
            ), // t('masterDataManagement.suppliers.table.dialog.form.additionalProperties.table.emptyMessageDetails')
            emptyMessageTitle: getTranslationsForConfig(
              'masterDataManagement.suppliers.table.dialog.form.additionalProperties.table.emptyMessageTitle',
            ), // t('masterDataManagement.suppliers.table.dialog.form.additionalProperties.table.emptyMessageTitle')
            paginator: true,
            rows: 20,
            rowsPerPageOptions: [20, 50, 100],
          },
        },
      },
    },
  }
}
